import { AbstractIconComponent } from './abstract.icon'
import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ColorPipe } from '../pipes/color.pipe'

type IconDirection = 'top' | 'down' | 'left' | 'right'

@Component({
  selector: 'icon-arrow',
  templateUrl: './arrow.icon.html',
  styleUrls: ['./arrow.icon.scss'],
  imports: [CommonModule, ColorPipe],
})
export class ArrowIconComponent extends AbstractIconComponent {
  static icon = 'arrow'

  @Input() direction: IconDirection = 'top'
}
